import { Pipe, PipeTransform } from '@angular/core';

const units = ['B', 'KB', 'MB', 'GB', 'TB'];
@Pipe({
    name: 'fileSize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {
    transform(size?: any): string {
    	if (!size) return '0 B';
  	
    	let l = 0, n = parseInt(size, 10) || 0;
    	while(n >= 1024 && ++l){
          n = n/1024;
    	}
    	return(n.toFixed(n < 10 && l > 0 ? 2 : 0) + ' ' + units[l]);
//    	return (size / (1024 * 1024)).toFixed(2) + 'MB';
    }
}
